import { css } from '@emotion/react';

import { useScanEditingContextSlice } from '@kaiizen/kai-pro-api-react-state';
import {
  ScanGroupOptimized,
  ScanTaskOptimized,
} from '@kaiizen/kai-scan-template-system';

import { GroupProgressEditor } from './GroupProgressEditor';
import { ProgressHeader } from './ProgressHeader';
import { TaskProgressEditor } from './TaskProgressEditor';

const PROGRESS_WALK_EDITOR_STYLE = css`
  label: PROGRESS_WALK_EDITOR_STYLE;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-width: 0;
`;

export const ProgressEditor = ({
  group,
  scopedGroups,
  task,
  scopedTasks,
  setCurrentGroupIdAndTaskId,
}: {
  scopedTasks: ScanTaskOptimized[];
  scopedGroups: ScanGroupOptimized[];
  group?: ScanGroupOptimized;
  task?: ScanTaskOptimized;
  setCurrentGroupIdAndTaskId: (groupId: string | undefined, taskId: string | undefined) => void;
}) => {
  const { baselineScanRoot, scanId, scanDataMutators } = useScanEditingContextSlice(['baselineScanRoot', 'scanRoot', 'scanId', 'scanDataMutators']);

  const baselineGroup = group ? baselineScanRoot?.groupsById[group.id] : undefined;

  const scanPart = task ?? group;

  return (
    <div css={PROGRESS_WALK_EDITOR_STYLE}>
      <ProgressHeader
        scanId={scanId}
        group={group}
        task={task}
        groups={scopedGroups}
        tasks={scopedTasks}
        setCurrentGroupIdAndTaskId={setCurrentGroupIdAndTaskId}
      />
      {task && group && scanPart
        ? (
          <TaskProgressEditor
            scanId={scanId}
            scanPart={scanPart}
            scanDataMutators={scanDataMutators}
            groupId={group.id}
            taskId={task?.id}
          />
        )
        : group && baselineGroup
        ? (
          <GroupProgressEditor
            scanId={scanId}
            group={group}
            baselineGroup={baselineGroup}
            scanDataMutators={scanDataMutators}
          />
        )
        : null}
    </div>
  );
};
